// extracted by mini-css-extract-plugin
export default {"newUi":"PRCQky"};